<template>
  <div class="h-full grid grid-cols-6">
    <div
      class="col-start-1 col-span-6 md:col-span-3 lg:col-span-2 xl:col-span-2 flex content-center flex-wrap"
    >
      <div class="text-left">
        <p class="text-6xl font-hairline">Ooops.</p>
        <p class="text-4xl font-bold text-primary">It can't be worst,</p>
        <p class="text-2xl font-bold">We've been notified about this issue automatically.</p>
      </div>
    </div>
    <div
      class="col-start-1 md:col-start-4 lg:col-start-3 xl:col-start-3 col-span-6 md:col-span-3 lg:col-span-4 xl:col-span-4 flex content-center flex-wrap"
    >
      <img src="../../assets/img/fatal-error.png" alt="Logo Koehler" />
    </div>
  </div>
</template>

<script>
export default {
  name: "InternalError",
};
</script>
